import React from "react";
import { UserRound } from "lucide-react";
import { Heart } from "lucide-react";
import { ShoppingBag } from "lucide-react";
import { History } from "lucide-react";
import { MapPinHouse } from "lucide-react";
import { UserRoundPen } from "lucide-react";
import { Car } from "lucide-react";
import { LogOut } from "lucide-react";
import { Link } from "react-router-dom";
export default function AccountNav() {
  return (
    <div>
      <div
        style={{ height: "80vh", width: "300px" }}
        className="hidden  lg:block py-10 px-2"
      >
        <ul className="space-y-2" style={{ height: "90vh" }}>
          <li className=" m-1 hover:text-white">
            <Link to="/account/dashboard">
              <div className="bg-[#EFF6FF] hover:bg-blue-900 hover:text-white text-gray-700 p-2 rounded flex items-center">
                <UserRound />
                <span className="text-[18px] font-semibold ml-2 p-[5px]">Dashboard</span>
              </div>
            </Link>
          </li>
          <li className=" m-1 hover:text-white">
            <Link to="/account/wishlist">
              <div className="bg-[#EFF6FF] hover:bg-blue-900 hover:text-white text-gray-700 p-2 rounded flex items-center">
                <Heart />
                <span className="text-[18px] font-semibold ml-2 p-[5px]">Wishlist</span>
              </div>
            </Link>
          </li>
          <li className=" m-1 hover:text-white">
            <Link to="/account/orders">
              <div className="bg-[#EFF6FF] hover:bg-blue-900 hover:text-white text-gray-700 p-2 rounded flex items-center">
                <ShoppingBag />
                <span className="text-[18px] font-semibold ml-2 p-[5px]">Orders</span>
              </div>
            </Link>
          </li>
          <li className=" m-1 hover:text-white">
            <Link to="/account/edit-address">
              <div className="bg-[#EFF6FF] hover:bg-blue-900 hover:text-white text-gray-700 p-2 rounded flex items-center">
                <MapPinHouse />
                <span className="text-[18px] font-semibold ml-2 p-[5px]">Addresses</span>
              </div>
            </Link>
          </li>
          <li className=" m-1 hover:text-white">
            <Link to="/account/edit-account">
              <div className="bg-[#EFF6FF] hover:bg-blue-900 hover:text-white text-gray-700 p-2 rounded flex items-center">
                <UserRoundPen />
                <span className="text-[18px] font-semibold ml-2 p-[5px]">Account details</span>
              </div>
            </Link>
          </li>
          {/* <li className="m-1 hover:text-white">
                        <div className="bg-gray-200 hover:bg-blue-600 hover:text-white text-gray-700 p-2 rounded flex items-center">
                            <LogOut />
                            <span className="text-md ml-2">Log out</span>
                        </div>
                    </li> */}
        </ul>
      </div>
    </div>
  );
}
